import React, { useState, useContext, ChangeEvent, useEffect } from 'react'
import { Button, Form, Input, message } from 'antd'
import { useQuery } from 'react-query'
import { IResponseTokens } from '@interfaces/IAuth'
import { UserContext } from '@context/UserContext'
import config from '@config/config'

const LoginForm: React.FC = () => {
    const [form, setForm] = useState({ userName: '', password: '' })
    const auth = useContext(UserContext)

    const changeUserData = (event: ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [event.target.name]: event.target.value })
    }

    const loginHandler = () => {
        refetch();
    }

    const { isLoading, isError, error, refetch } = useQuery<IResponseTokens, Error>(
        'auth',
        async () => {
            return await auth.login(form.userName, form.password)
        },
        {
            ...config.useQueryAuthConfig,
            onSuccess: (res) => {
                message.success("Авторизован!")
            },
            onError: (err) => {
                message.error("Ошибка авторизации!")
            },
        }
    )

    useEffect(() => {
        localStorage.setItem('endDateColor', '')
        localStorage.setItem('uspdFilters', JSON.stringify({}))
        localStorage.setItem('tankFilters', JSON.stringify({}))
        localStorage.setItem('containerFilters', JSON.stringify({}))
        localStorage.setItem('deviceFilters', JSON.stringify({end_date: ''}))
    }, [])

    return (
        <Form>
            <h1 style={{textAlign: 'center', marginBottom: '30px'}}>Авторизация</h1>
            {isError && <div style={{ color: 'red' }}>{error.message}</div>}
            <Form.Item
                label="Имя пользователя"
                name="name"
                rules={[{ required: true, message: 'Пожалуйста введите имя пользователя!' }]}
            >
                <Input type="text" name="userName" onChange={changeUserData} />
            </Form.Item>
            <Form.Item
                label="Пароль"
                name="password"
                rules={[{ required: true, message: 'Пожалуйста введите пароль' }]}
            >
                <Input type="password" name="password" onChange={changeUserData} />
            </Form.Item>
            <Form.Item>
                <Button 
                    type="primary" 
                    htmlType="submit" 
                    loading={isLoading} 
                    onClick={loginHandler}
                >
                    Войти
                </Button>
            </Form.Item>
        </Form>
    )
}

export default LoginForm
